import useUserDetails, { AccessArea, AccessRight } from '@/composables/users/user-details'

export { AccessArea, AccessRight }

export default function useAuthenticatedUserDetails() {
  return useUserDetails('me')
}
